export default "__VITE_ASSET__B3CZU3NQ__"